<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加产品类型按钮 -->
      <el-row>
        <el-col>
          <el-button type="success" @click="addDialogVisible = true">新增订单</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 商品信息表格 -->
        <el-button
          icon="el-icon-download"
          circle
          @click="getpdfyes"
          class="download"
          type="warning"
          size="medium"
        ></el-button>
        <el-table id="pdfDom" :data="ordersList" border stripe class="123">
          <el-table-column type="index"></el-table-column>
          <el-table-column label="订单编号" prop="OrderNO"></el-table-column>
          <el-table-column label="订单名称" prop="OrderName" width="100%"></el-table-column>
          <el-table-column label="订单状态" prop="OrderState" width="90px"></el-table-column>
          <!-- <el-table-column label="创建时间" prop="CreateTime" width="160px">
            <template slot-scope="scope">
              {{ scope.row.CreateTime | dateFormat }}
            </template>
          </el-table-column> -->
          <el-table-column label="备注" prop="Remark" width="100px"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-position" size="mini" @click="doOrder(scope)">下发</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeType(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑产品信息的会话框 -->
    <el-dialog title="修改产品类型信息" :visible.sync="editDialogVisible" width="30%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
        <el-form-item label="产品类型" prop="TypeName">
          <el-input v-model="editForm.TypeName"></el-input>
        </el-form-item>
        <el-form-item label="产品类型编号" prop="TypeNo">
          <el-input v-model="editForm.TypeNo"></el-input>
        </el-form-item>
        <el-form-item label="创建人" prop="CreateUser">
          <el-input v-model="editForm.CreateUser" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="库存下限" prop="Stock_Down" required>
          <el-input v-model.number="editForm.Stock_Down"></el-input>
        </el-form-item>
        <el-form-item label="库存上限" prop="Stock_Up" required>
          <el-input v-model.number="editForm.Stock_Up"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加订单信息的对话框 -->
    <el-dialog title="添加订单" :visible.sync="addDialogVisible" width="40%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="订单名称" prop="OrderName">
          <el-input v-model="addForm.OrderName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="下发类型" prop="DistributeType">
          <el-select v-model="addForm.DistributeType" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="addForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <div class="btn02">
          <el-button type="success" @click="addOrder" size="medium">① 保 存</el-button>
        </div>
        <el-divider></el-divider>
        <h4>订单明细</h4>
        <div class="order01">
          <el-form-item label="产品" prop="DistributeType">
            <el-select v-model="addForm.ProductSet_ID" placeholder="请选择">
              <el-option
                v-for="item in productList"
                :key="item.ID"
                :label="item.ProductName"
                :value="item.ID"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工艺" prop="TechnologySet_ID">
            <el-select v-model="addForm.TechnologySet_ID" placeholder="请选择">
              <el-option
                v-for="item in CraftList"
                :key="item.ID"
                :label="item.TechnologyName"
                :value="item.ID"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓位" prop="StorageLocationNO">
            <el-select v-model="addForm.StorageLocationNO" placeholder="请选择">
              <el-option
                v-for="item in storageList"
                :key="item.ID"
                :label="item.StorageLocationNO"
                :value="item.StorageLocationNO"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="btn01">
            <el-button type="info" @click="addOrderDetails()">② 添 加</el-button>
          </div>
        </div>
        <div>
          <el-table :data="OrderDetailsList" border stripe>
            <el-table-column type="index"></el-table-column>
            <el-table-column label="产品" prop="ProductName"></el-table-column>
            <el-table-column label="工艺" prop="TechnologyName"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeOrderDetails(scope)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getOrderListById()">③ 提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: 1,
                limit: 5,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Mes_Order'
            },
            getTypeList1: {
                page: 1,
                limit: 100,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Mes_Order'
            },
            tableNameC: 'Mes_TechnologySet',
            tableNamee: 'mes_order_detail',
            // 订单信息列表
            ordersList: [],
            // 总数据条数
            total: 0,
            // 控制修改信息对话框的显示与隐藏
            editDialogVisible: false,
            // 控制添加信息对话框的显示与隐藏
            addDialogVisible: false,
            // 编辑用户信息的表单
            editForm: {},
            // 添加用户的表单数据
            addForm: {
                OrderName: '',
                DistributeType: '',
                Remark: '',
                ProductSet_ID: '',
                TechnologySet_ID: '',
                Order_ID: '',
                StorageLocationNO: ''
            },
            //添加表单的验证规则对象
            addFormRules: {
                TypeName: [
                    { required: true, message: '请选择产品类型', trigger: 'blur' }
                ],
                CreateUser: [
                    { required: true, message: '请输入创建人', trigger: 'blur' },
                    {
                        min: 2,
                        max: 15,
                        message: '用户名的长度在2~15个字符之间',
                        trigger: 'blur'
                    }
                ],
                CreateTime: [
                    { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                ],
                Is_Use: [
                    { required: true, message: '请输入是否启用', trigger: 'blur' },
                    {
                        min: 1,
                        max: 3,
                        message: '用户名的长度在1~3个字符之间',
                        trigger: 'blur'
                    }
                ],
                Stock_Down: [
                    { type: "number", message: '输入必须为大于等于0的整数', trigger: 'blur' }
                ],
                Stock_Up: [
                    { type: "number", message: '输入必须为大于等于0的整数', trigger: 'blur' }
                ]
            },
            // 修改表单的验证规则对象
            editFormRules: {
                TypeName: [
                    { required: true, message: '请输入类型', trigger: 'blur' },
                ],
                CreateUser: [
                    { required: true, message: '请输入创建人', trigger: 'blur' },
                ],
                Stock_Down: [
                    { type: "number", message: '输入必须为大于等于0的整数', trigger: 'blur' }
                ],
                Stock_Up: [
                    { type: "number", message: '输入必须为大于等于0的整数', trigger: 'blur' }
                ]
            },
            // 订单下发类型
            options: [{
                value: '0',
                label: '手动'
            }, {
                value: '1',
                label: '自动'
            }],
            // 产品信息表
            productList: [],
            // 工艺信息表
            CraftList: [],
            // 订单明细信息表
            OrderDetailsList: [],
            // 根据ID查询到的订单信息
            OrderListById: [],
            DistributeType1: '',
            // 仓库储位信息表
            storageList: []
        }
    },
    created () {
        this.getType()
        this.getType1()
        this.getproductList()
        this.getCraftList()
        this.getStorageList()
    },
    // mounted () {
    //     this.timer = setInterval(() => {
    //         this.getType()
    //     }, 2000);
    //     this.$once('hook:beforeDestroy', () => {
    //         clearInterval(timer);
    //     })
    // },
    // beforeDestroy () {
    //     clearInterval(this.timer);
    //     this.timer = null;
    // },
    methods: {
        // 调用接口获取订单信息
        async getType () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList })
            console.log(res.data)
            // for (var i = 0; i < res.data.length; i++) {
            //     if (res.data[i].Is_Use == 'Y') {
            //         res.data[i].Is_Use = '是'
            //     }
            //     if (res.data[i].Is_Use == 'N') {
            //         res.data[i].Is_Use = '否'
            //     }
            // }
            this.ordersList = res.data
        },
        // 调用接口获取订单信息
        async getType1 () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList1 })
            console.log(res.data)
            this.total = res.data.length
            // console.log(res.data.length)
        },
        // 调用接口删除订单信息
        async removeType (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该订单, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/WMS/DeleteOrderDetails', params)
            console.log(res)
            if (res != 1) {
                return this.$message.error('删除失败！')
            }
            this.$message.success('删除成功！')
            this.getType()
            this.getType1()
        },
        // 订单下发
        async doOrder (scope) {
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("page", this.getTypeList.page)
            params.append("limit", this.getTypeList.limit)
            params.append("operationType", '4')
            const { data: res } = await this.$http.post('/WMS/OperationType', params)
            console.log(res)
            if (res != 1) {
                return this.$message.error('订单已下发！')
            }
            this.getType()
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        //  监听添加信息对话框的关闭事件
        addDialogClosed () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口保存订单信息
        addOrder () {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("OrderName", this.addForm.OrderName)
                params.append("DistributeType", this.addForm.DistributeType)
                params.append("Remark", this.addForm.Remark)
                console.log('00' + params)
                // 可以发起添加用户的网络请求
                const { data: res } = await this.$http.post('/WMS/InsertOrder', params)
                console.log(res)
                console.log(res.data)
                this.addForm.Order_ID = res
                // 隐藏添加用户的对话框
                // this.addDialogVisible = false
                // 重新获取用户列表数据
                this.getType()
                this.getType1()

            })
        },
        // 调用接口编辑产品类型
        editProduct () {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("TypeName", this.editForm.TypeName)
                params.append("CreateUser", this.editForm.CreateUser)
                params.append("ID", this.editForm.ID)
                params.append("CreateTime", this.editForm.CreateTime)
                params.append("Is_Use", this.editForm.Is_Use)
                params.append("Remark", this.editForm.Remark)
                params.append("Stock_Down", this.editForm.Stock_Down)
                params.append("Stock_Up", this.editForm.Stock_Up)
                params.append("TypeNo", this.editForm.TypeNo)
                const { data: res } = await this.$http.post('/WMS/updateProductType', params)
                console.log(res)
                if (res == -2) {
                    return this.$message.error('下限大于上限！')
                }
                if (res !== 1) {
                    return this.$message.error('更新产品类型信息失败！')
                }

                // 关闭对话框
                this.editDialogVisible = false
                // 刷新数据列表
                this.getType()
                this.getType1()
                // 提示修改成功
                this.$message.success('更新产品类型信息成功！')
            })
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getType()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.getTypeList.page = newPage
            this.getType()
        },
        getpdfyes () {
            this.getPdf()
        },
        //调用接口获取产品信息
        async getproductList () {
            const { data: res } = await this.$http.get('/WMS/OrderProduct', { params: this.getTypeList })
            console.log(res.data)
            this.productList = res.data
        },
        // 调用接口获取工艺信息
        async getCraftList () {
            let params = new URLSearchParams();
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("page", this.getTypeList.page)
            params.append("limit", this.getTypeList.limit)
            params.append("tableName", this.tableNameC)
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params })
            console.log(res.data)
            this.CraftList = res.data
        },
        // 调用接口新增订单明细
        async addOrderDetails () {
            let params = new URLSearchParams();
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("TechnologySet_ID", this.addForm.TechnologySet_ID)
            params.append("Order_ID", this.addForm.Order_ID)
            params.append("ProductSet_ID", this.addForm.ProductSet_ID)
            params.append("StorageLocationNO", this.addForm.StorageLocationNO)
            console.log('12345' + params)
            if (!this.addForm.ProductSet_ID) return
            const { data: res } = await this.$http.post('/WMS/InsertOrderDetail', params)
            console.log(res)
            if (res == -3) {
                return this.$message.error('产品重复！')
            }
            if (res == -4) {
                return this.$message.error('仓位重复！')
            }
            if (res !== 1) {
                return this.$message.error('系统异常，添加失败！')
            }
            this.getOrderDetailsList()
        },
        //调用接口查询订单明细
        async getOrderDetailsList () {
            let params = new URLSearchParams();
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("page", this.getTypeList.page)
            params.append("limit", this.getTypeList1.limit)
            params.append("Order_ID", this.addForm.Order_ID)
            console.log('123' + params)
            const { data: res } = await this.$http.get('/WMS/queryOrderDetail', { params })
            console.log(res)
            this.OrderDetailsList = res.data
        },
        // 根据ID查询订单信息
        async getOrderListById () {
            let params = new URLSearchParams();
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("ID", this.addForm.Order_ID)
            params.append("tableName", this.getTypeList.tableName)
            console.log('123' + params)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.OrderListById = res.data[0]
            if (!this.OrderListById.ID) return
            this.submitOrderDetails()
        },
        // 调用接口提交订单与订单明细
        async submitOrderDetails () {
            let params = new URLSearchParams();
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("DistributeType", this.OrderListById.DistributeType)
            params.append("ID", this.OrderListById.ID)
            params.append("OrderNO", this.OrderListById.OrderNO)
            params.append("OrderName", this.OrderListById.OrderName)
            params.append("OrderState", this.OrderListById.OrderState)
            params.append("Remark", this.OrderListById.Remark)
            params.append("TableState", this.OrderListById.TableState)
            console.log('123' + params)
            const { data: res } = await this.$http.post('/WMS/SubmitOrder', params)
            console.log(res)
            if (res != 1) {
                return this.$message.error('系统异常，提交失败！')
            }
            if (res == -6) {
                return this.$message.error('请勿重复提交！')
            }
            if (res == -8) {
                return this.$message.error('请添加明细！')
            }
            if (res == -5) {
                return this.$message.error('订单已结束')
            }
            this.$message.success("提交成功！")
            this.addDialogVisible = false
            // console.log(res)
            this.getType()
        },
        // 调用接口删除订单明细
        async removeOrderDetails (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该明细, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.tableNamee)
            const { data: res } = await this.$http.post('/WMS/GeneralDelete', params)
            console.log(res)
            if (res != 1) {
                return this.$message.error('删除失败！')
            }
            this.$message.success('删除成功！')
            this.getOrderDetailsList()
        },
        // 调用接口获取仓库储位信息
        async getStorageList () {
            let params = new URLSearchParams();
            params.append("limit", this.getTypeList1.limit)
            params.append("page", this.getTypeList.page)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/OrderProduct', { params })
            console.log(res.data1)
            this.storageList = res.data1
        },
    }
}
</script>

<style lang="less" scoped>
.download {
  position: absolute;
  left: 94%;
  top: 12%;
  transform: translate(50%, 50%);
}
.order01 {
  display: flex;
}
.btn01 {
  margin-left: 4%;
}
.btn02 {
  margin-left: 80%;
}
</style>

